// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3616": "2bd20f1d2224","5093": "b9600059acfc","6863": "454c9f289029","8357": "dd422574e14d","9366": "3bd787065709","9731": "4e43cf030518",}[chunkId] + ".css"
}